import script from "./navbar_styled_register.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar_styled_register.vue?vue&type=script&setup=true&lang=js"

import "./navbar_styled_register.vue?vue&type=style&index=0&id=28e4332a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28e4332a"]])

export default __exports__